import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    IFestivalPlan, IFestivalPlanRequest, IFestivalPreview, IFestivalRun, IFestivalRunDetail,
    IGratuityPreview, IGratuityRun, IGratuityRunDetail, IProvisionRunRequest, IProvisionSettings,
    IProvisionSettingsRequest, ISuggestedAccountsResult,
} from '../interfaces/payrollProvision.interface';

const headers = () => ({ headers: AuthService.getAuthHeader() });

// W3-J: gratuity provision, festival-bonus provision and the accounts they post to.
export const PayrollProvisionService = {
    getSettings: async (institutionId: string): Promise<IProvisionSettings> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.SETTINGS(institutionId), headers())).data,

    updateSettings: async (institutionId: string, req: IProvisionSettingsRequest): Promise<IProvisionSettings> =>
        (await axios.put(ENDPOINTS.PAYROLL_PROVISIONS.SETTINGS(institutionId), req, headers())).data,

    createSuggestedAccounts: async (institutionId: string): Promise<ISuggestedAccountsResult> =>
        (await axios.post(ENDPOINTS.PAYROLL_PROVISIONS.SUGGESTED_ACCOUNTS(institutionId), null, headers())).data,

    // ---- gratuity ----
    gratuityRuns: async (institutionId: string): Promise<IGratuityRun[]> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.GRATUITY_RUNS(institutionId), headers())).data,

    gratuityPreview: async (institutionId: string, year: number, month: number): Promise<IGratuityPreview> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.GRATUITY_PREVIEW(institutionId), { ...headers(), params: { year, month } })).data,

    gratuityPost: async (institutionId: string, req: IProvisionRunRequest): Promise<IGratuityRun> =>
        (await axios.post(ENDPOINTS.PAYROLL_PROVISIONS.GRATUITY_RUNS(institutionId), req, headers())).data,

    gratuityRun: async (runId: string): Promise<IGratuityRunDetail> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.GRATUITY_RUN(runId), headers())).data,

    gratuityReverse: async (runId: string): Promise<IGratuityRun> =>
        (await axios.post(ENDPOINTS.PAYROLL_PROVISIONS.GRATUITY_REVERSE(runId), null, headers())).data,

    // ---- festival bonus ----
    festivalPlans: async (institutionId: string): Promise<IFestivalPlan[]> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_PLANS(institutionId), headers())).data,

    createFestivalPlan: async (institutionId: string, req: IFestivalPlanRequest): Promise<IFestivalPlan> =>
        (await axios.post(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_PLANS(institutionId), req, headers())).data,

    updateFestivalPlan: async (planId: string, req: IFestivalPlanRequest): Promise<IFestivalPlan> =>
        (await axios.put(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_PLAN(planId), req, headers())).data,

    deleteFestivalPlan: async (planId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_PLAN(planId), headers());
    },

    festivalRuns: async (institutionId: string): Promise<IFestivalRun[]> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_RUNS(institutionId), headers())).data,

    festivalPreview: async (institutionId: string, year: number, month: number): Promise<IFestivalPreview> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_PREVIEW(institutionId), { ...headers(), params: { year, month } })).data,

    festivalPost: async (institutionId: string, req: IProvisionRunRequest): Promise<IFestivalRun> =>
        (await axios.post(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_RUNS(institutionId), req, headers())).data,

    festivalRun: async (runId: string): Promise<IFestivalRunDetail> =>
        (await axios.get(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_RUN(runId), headers())).data,

    festivalReverse: async (runId: string): Promise<IFestivalRun> =>
        (await axios.post(ENDPOINTS.PAYROLL_PROVISIONS.FESTIVAL_REVERSE(runId), null, headers())).data,
};
